import React, { useEffect } from 'react';
import styled from 'styled-components';
import { Alert, Space, Tag } from 'tdesign-react';
import { connect } from 'react-redux';
import { useSearchParams } from 'react-router-dom';
import { useMemoizedFn } from 'ahooks';
import { setCurrentTopic } from '@/slices/messageSARSlice';
import { randomString } from '@/utils/common';
import SvgIcon from '@/components/SvgIcon';

function Header({ setCurrentTopic, currentTopic }) {
  const [searchParams] = useSearchParams();
  const clusterName = searchParams.get('name');

  const createTempTopic = useMemoizedFn(() => {
    const randomTopic = randomString(7);
    const fullTopicName = `persistent://as/demo/${randomTopic}`;
    setCurrentTopic({
      topic: randomTopic,
      namespace: 'as/demo',
      tenant: 'as',
      clusterName,
      fullTopicName,
    });
  });

  // 初始化时执行一次
  useEffect(() => {
    createTempTopic();
  }, [createTempTopic, clusterName]);

  return (
    <Root>
      <Alert
        icon={<SvgIcon type='trumpet' />}
        message={
          <Space align='center' size={10}>
            已自动创建临时Topic<Tag>{currentTopic?.fullTopicName}</Tag>
            进行消息收发测试（退出后系统会统一回收清理）
          </Space>
        }
      />
    </Root>
  );
}

export default connect(
  (state) => ({
    submitting: state.messageSAR.submitting,
    currentTopic: state.messageSAR.currentTopic,
  }),
  {
    setCurrentTopic,
  },
)(Header);

const Root = styled.div`
  padding: 20px 20px 20px 0;
  .t-form {
    .t-form__item {
      margin-right: var(--td-comp-margin-m);
    }
  }
  .t-alert__icon {
    width: 16px;
    height: 16px;
  }
  .t-alert__description {
    color: #000;
  }
`;
